$('form[data-form-search]').submit(function (e) {
    e.preventDefault(); // Prevent default form submission

    var searchTargetUrl = $(this).attr("data-form-search-target");
    var searchQueryPrependHash = $(this).attr("data-form-search-prepend-hash");
    var serializedInput = $(this).find('*').not('[data-form-exclude]').serialize();

    // Function to parse query strings into objects (like in JavaScript)
    function parseParams(queryString) {
        return queryString.split('&').reduce(function (acc, param) {
            var [key, value] = param.split('=');
            if (key) acc[key] = decodeURIComponent(value ? value.replace(/\+/g, ' ') : '');
            return acc;
        }, {});
    }

    // Function to serialize objects into query strings (like in JavaScript)
    function serializeParams(params) {
        return Object.keys(params)
            .map(function (key) {
                return key + '=' + encodeURIComponent(params[key]);
            })
            .join('&');
    }

    // Get current hash parameters
    var currentHashParams = window.location.hash.length > 1 ? parseParams(window.location.hash.substring(1)) : {};

    // Parse new form input parameters
    var newParams = parseParams(serializedInput);

    // Remove the searchQueryPrependHash from newParams if it exists
    if (searchQueryPrependHash) {
        var hashParamKey = searchQueryPrependHash.split('=')[0]; // Extract the key, e.g., "sitesearchresults_e"
        delete newParams[hashParamKey]; // Remove it from the newParams if it exists
    }

    // Merge parameters, giving precedence to newParams
    var mergedParams = Object.assign({}, currentHashParams, newParams);

    // Serialize merged parameters
    var mergedParamsString = serializeParams(mergedParams);

    // Simulate the updated URL construction
    var newUrl;

    if (!searchTargetUrl || searchTargetUrl === '/' || searchTargetUrl === window.location.pathname)
    {
        $('#headerSearchModal').modal('hide');
        hideMobileSearch();
    }

    // If searchQueryPrependHash exists, ensure it remains intact and not merged
    if (searchQueryPrependHash && !currentHashParams[hashParamKey]) {
        // Add searchQueryPrependHash at the start of the hash, followed by the merged parameters
        newUrl = searchTargetUrl + '#' + searchQueryPrependHash + '&' + mergedParamsString;
    } else {
        // If no searchQueryPrependHash, just update the hash with merged params
        newUrl = searchTargetUrl + '#' + mergedParamsString;
    }

    // Update the URL without reloading the page
    window.location.href = newUrl;
});

// Updates the URL while preserving the hash
function changeQueryString(queryString) {
    var newUrl = window.location.pathname + window.location.search + '#' + queryString;
    window.history.pushState({ path: newUrl }, '', newUrl);
}
